import { memo } from 'react';
import { Incident } from '../types/domain';
import { severityColor } from '../utils/incidents';

export const IncidentTimeline = memo(function IncidentTimeline({ incidents }: { incidents: Incident[] }) {
  return (
    <div className="space-y-3">
      {incidents.length === 0 ? <p className="rounded-xl border border-dashed border-white/15 p-5 text-sm text-slate-400">No incidents logged yet.</p> : null}
      {incidents.map((incident) => (
        <article key={incident.id} className="rounded-xl border border-white/10 bg-white/[0.06] p-4">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <p className="font-semibold text-white">{incident.label}</p>
              <p className="text-sm text-slate-400">
                {new Date(incident.timestamp).toLocaleTimeString()} · {incident.source} · {incident.durationSeconds ?? incident.elapsedSeconds}s
              </p>
            </div>
            <span className={`rounded-md px-2.5 py-1 text-xs font-bold uppercase ${severityColor(incident.severity)}`}>{incident.severity}</span>
          </div>
          <div className="mt-3 h-2 overflow-hidden rounded-full bg-white/10">
            <div className="h-full bg-gradient-to-r from-neon-violet to-neon-blue" style={{ width: `${incident.confidence}%` }} />
          </div>
          {incident.screenshot ? <img src={incident.screenshot} alt="" className="mt-3 h-24 rounded-md object-cover" /> : null}
        </article>
      ))}
    </div>
  );
});
